// PasteButton.jsx
import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from "react-i18next";
import {enqueueSnackbar} from "notistack";
const PasteButton = ({ onPaste }) => {
  const {t}=useTranslation()
  const handlePasteClick = async () => {
    try {
      const text = await navigator.clipboard.readText();
      if (onPaste) {
        onPaste(text);
      }
    } catch (error) {
      console.error("Failed to paste from clipboard:", error);
      enqueueSnackbar(t("browser_paste_error"), { variant: 'error' })
    }
  };

  return (
      <Box className={'color-error-dark'} onClick={handlePasteClick}>
        {t("paste")}
      </Box>
  );
};

export default PasteButton;
